<script>
  import { createEventDispatcher } from 'svelte';
  import Button from '@components/Button.svelte';
  import AppInviteAjax from '@ajax/app_invite';
  import Notification from '@utils/notification';
  import jQuery from 'jquery';
  import Track from '@utils/track';
  import Mixpanel from '@utils/mixpanel';

  const dispatch = createEventDispatcher();

  export let pendingUserData = {};
  export let mobile = false;
  export let convertPendingUserToActualUser;

  let letter1;
  let letter2;
  let letter3;
  let letter4;
  let letter5;

  let letter1El;
  let letter2El;
  let letter3El;
  let letter4El;
  let letter5El;

  let previousValue;

  let verifyingCode = false;
  let verifyCodeFailed;
  let showNoInviteCodeScreen = false;

  let addCodeWithPaste = function (e) {
    e.preventDefault();
    e.stopPropagation();

    let clipboardData = e.clipboardData || window.clipboardData;
    let pastedData = clipboardData.getData('Text');

    if (pastedData.length === 5) {
      letter1 = pastedData[0];
      letter2 = pastedData[1];
      letter3 = pastedData[2];
      letter4 = pastedData[3];
      letter5 = pastedData[4];

      jQuery(e.target).blur();
      verifyCode();
    }
  };

  let convertPendingUserToUserWithInvite = async function (invite) {
    try {
      let newUser = await convertPendingUserToActualUser(pendingUserData.code, invite.code, pendingUserData.name);

      dispatch('finished', {
        user: newUser,
        inviteCode: invite.code,
      });
    } catch (err) {
      if (err && err.full_errors && err.full_errors.length > 0) {
        Notification.send({
          text: err.full_errors[0],
          type: 'error',
        });
      }
    }
  };

  let displayNoInviteCodeScreen = function () {
    showNoInviteCodeScreen = true;

    Track.skipWaitlistClick({
      pendingUserEmail: pendingUserData && pendingUserData.email,
      pageUrl: window.location.href,
    });
  };

  let fullCode = function () {
    return `${letter1}${letter2}${letter3}${letter4}${letter5}`;
  };

  let verifyCode = async function () {
    verifyingCode = true;
    verifyCodeFailed = undefined;

    try {
      let invite = await AppInviteAjax.get(fullCode(), {
        withErrorHandling: false,
      });

      convertPendingUserToUserWithInvite(invite);
      Mixpanel.track('user:create');
    } catch (err) {
      verifyingCode = false;
      const errorResponse = err && err.responseJSON;
      if (errorResponse && errorResponse.full_errors && errorResponse.full_errors.length > 0) {
        verifyCodeFailed = errorResponse.full_errors[0];
      } else {
        verifyCodeFailed = 'The invite code you entered was invalid';
      }
    }
  };

  let inputDataAdded = function (event, nextInput, prevInput) {
    const { value } = event.target;

    if (fullCode().length === 5) {
      verifyCode();
      return;
    }

    // This is a workaround for dealing mobile chrome does not fire "paste" event from sms auto-populate.
    if (!(letter1 && letter1.length) && value.length === 5) {
      event.clipboardData = {
        getData: () => value.trim(),
      };
      addCodeWithPaste(event);
      return;
    }

    if (event.keyCode === 8 && (previousValue != '' || previousValue)) {
      previousValue = '';
    } else if (prevInput && event.keyCode === 8) {
      prevInput.focus();
    } else if (nextInput && event.target.value.length === 1) {
      nextInput.focus();
    }
  };

  let continueFlow = async function () {
    letter1 = 'w';
    letter2 = 'a';
    letter3 = 'i';
    letter4 = 't';
    letter5 = '1';

    verifyCode();
  };

  let setFocus = function (node) {
    if (!mobile && !verifyCodeFailed) {
      node.focus();
    }
  };
</script>

<style style="text/scss" lang="scss">
  .invite-code {
    margin-top: 20px;

    .invite-code-container {
      margin-top: 40px;
    }

    .ui-header {
      font-size: 32px;
      line-height: 40px;
      text-align: center;
      margin-top: 32px;
    }

    .ui-subheader {
      font-size: 16px;
      line-height: 28px;
      text-align: center;
      color: #7f7f7f;
      margin-top: 16px;
      width: 580px;
      margin-left: auto;
      margin-right: auto;
    }

    .code-container {
      display: flex;
      flex-direction: column;
      margin-top: 46px;

      .code-container-header {
        font-size: 16px;
        line-height: 24px;
        text-align: center;
        margin-bottom: 25px;
      }

      .code-input {
        border: 2px solid #ececec;
        border-radius: 16px;
        width: 56px;
        height: 56px;
        font-size: 24px;
        color: #a893f9;
        text-align: center;
        -webkit-appearance: none;
        max-width: 18% !important;

        &:focus {
          outline: none;
          background: #f5f3fc;
          border: 2px solid #a893f9;
        }
      }

      .invite-failed {
        font-size: 16px;
        line-height: 20px;
        text-align: center;
        color: #ff5567;
        margin-top: 4px;
      }

      .verifying-code {
        i {
          font-size: 32px;
          color: #a893f9;
        }
      }
    }

    .ui-request-header {
      font-weight: bold;
      font-size: 32px;
      line-height: 40px;
      margin-top: 36px;
    }

    .ui-request-text {
      font-size: 18px;
      line-height: 24px;
      color: #717171;
      margin-top: 20px;
    }

    .ui-request-button {
      width: 100%;
      max-width: 580px;
      margin-left: auto;
      margin-right: auto;
      margin-top: 60px;

      :global(button) {
        background: #7a5cfa;
        border-radius: 999px !important;
        width: 100% !important;
        height: 48px !important;
      }
    }

    .ui-back-btn {
      position: absolute;
      top: 25px;
      font-size: 15px;
      line-height: 18px;
      cursor: pointer;

      .fa {
        margin-right: 10px;
        color: #d5cfea;
      }

      span {
        color: #000000;
        opacity: 0.5;
      }
    }
  }

  .mobile {
    padding: 20px;

    .ui-header {
      font-weight: bold;
      font-size: 25px;
      line-height: 32px;
    }

    .ui-request-header {
      font-size: 20px;
      line-height: 28px;
    }

    .ui-request-text {
      font-size: 16px;
      line-height: 24px;
    }

    .request-invite-container {
      margin-top: 40px;
      min-height: 300px;
    }

    .ui-subheader {
      width: 100%;
      font-weight: normal;
      font-size: 14px;
      line-height: 23px;
    }

    .code-container {
      margin-top: 40px;

      .code-container-header {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 16px;
      }
    }
  }

  .skip-waitlist-link {
    color: #896bd9;
    font-weight: 500;
  }

  .partying-face {
    margin-top: 80px;

    img {
      width: 80px;
      height: 80px;
    }
  }

  * :global(.has-left-icon) {
    margin-left: 4px;
  }
</style>

<div class="invite-code" class:mobile={mobile}>
  {#if showNoInviteCodeScreen}
    <div class="request-invite-container">
      <div class="partying-face">
        <img src="/images/app-invites/partying-face.png" />
      </div>

      <div class="ui-request-header">Congrats, you skipped the waitlist!</div>
      <div class="ui-request-text">You just claimed one of today's last daily invite spots.</div>
      <div class="ui-request-button">
        <Button
          text={verifyingCode ? '<i class="fa fa-spinner fa-spin"></i>&nbsp;&nbsp;Working...' : 'Continue'}
          on:click={continueFlow}
          disabled={verifyingCode} />
      </div>
    </div>
  {:else}
    <div class="invite-code-container">
      <img src="/images/app-invites/party.svg" />
      <div class="ui-header" style="font-weight: bold;">You're on the waitlist!</div>
      <div class="ui-subheader" style="margin-top: 28px;">
        Benable is currently <span style="font-weight: bold; color: black">invite-only.</span><br />If you don't have a
        code,
        <a href="#" class="skip-waitlist-link" on:click|preventDefault={displayNoInviteCodeScreen}
          >click here to skip the waitlist</a>
      </div>
      <div class="code-container">
        <div class="code-container-header">Already have an invite code? Enter it below</div>

        {#if verifyingCode}
          <div class="verifying-code">
            <i class="fa fa-spinner fa-spin" />
          </div>
        {:else}
          <div>
            <input
              use:setFocus
              on:focus={(event) => (previousValue = event.target.value)}
              on:input={(event) => inputDataAdded(event, letter2El, null)}
              bind:this={letter1El}
              bind:value={letter1}
              type="text"
              class="code-input"
              maxlength="5"
              on:paste={addCodeWithPaste} />
            <input
              on:focus={(event) => (previousValue = event.target.value)}
              on:keyup={(event) => inputDataAdded(event, letter3El, letter1El)}
              bind:this={letter2El}
              type="text"
              class="code-input"
              maxlength="1"
              bind:value={letter2} />
            <input
              on:focus={(event) => (previousValue = event.target.value)}
              on:keyup={(event) => inputDataAdded(event, letter4El, letter2El)}
              bind:this={letter3El}
              type="text"
              class="code-input"
              maxlength="1"
              bind:value={letter3} />
            <input
              on:focus={(event) => (previousValue = event.target.value)}
              on:keyup={(event) => inputDataAdded(event, letter5El, letter3El)}
              bind:this={letter4El}
              type="text"
              class="code-input"
              maxlength="1"
              bind:value={letter4} />
            <input
              on:focus={(event) => (previousValue = event.target.value)}
              on:keyup={(event) => inputDataAdded(event, null, letter4El)}
              bind:this={letter5El}
              type="text"
              class="code-input"
              maxlength="1"
              bind:value={letter5} />
          </div>

          {#if verifyCodeFailed}
            <div class="invite-failed">
              {verifyCodeFailed}
            </div>
          {/if}
        {/if}
      </div>
    </div>
  {/if}
</div>
